import React, { useState, useEffect, useMemo, useCallback } from "react"
import { createPortal } from "react-dom"
import { useGlobalContext } from "../data/GlobalContext"
import { promotionsData } from "../data/PromotionData"
import CountdownTimer from "../data/CountdownTimer"
import Deposit from "../transactions/Deposit"
import LuckyDraw8 from "./games/LuckyDraw8"
import RollingCommission from "../promotions/RollingCommission"
import ModuleFaChaiGrandSpinAle from "../promotions/promotion_modules/modules_fcGrandSpinAle"
import ModulesLotteryDraw from "../promotions/promotion_modules/modules_lotterDraw"
import ModulesPeraBayong from "../promotions/promotion_modules/modules_peraBayong"
import ModuleJustDoYourBest from "../promotions/promotion_modules/modules_justDoYourBest"
import LoginToPlay from "../data/LoginToPlay"
import ModuleFlexiShowDown from "../promotions/promotion_modules/modules_flexiSpinShowdown"
import ModuleCQ9Funalo from "../promotions/promotion_modules/modules_cq9Funalo"

export default function FeaturedPromoMobile() {
  const [isFeaturedPromoOpen, setIsFeaturedPromoOpen] = useState(true)
  const [isFeaturedPromoPop, setIsFeaturedPromoPop] = useState(false)
  const { setShowEasterEgg, showMysteryFridayBtn, doubleUpTurnover } =
    useGlobalContext()
  const [isShowViewEntry, setIsShowViewEntry] = useState(false)
  const [showRolling, setShowRolling] = useState(false)
  const [activeModal, setActiveModal] = useState(null)
  const [isShowDoubleUp, setIsShowDoubleUp] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [login, setLogin] = useState(false)
  const [isDepositOpen, setIsDepositOpen] = useState(false)

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true")
  }, [])

  useEffect(() => {
    document.body.style.overflow = isFeaturedPromoPop ? "hidden" : "auto"
    return () => (document.body.style.overflow = "auto")
  }, [isFeaturedPromoPop])

  const handlePromoPop = () => {
    setIsFeaturedPromoOpen(false)
    setIsFeaturedPromoPop(true)
  }

  const handleClosePop = () => {
    setIsFeaturedPromoOpen(true)
    setIsFeaturedPromoPop(false)
  }

  const featuredPromotions = useMemo(() => {
    return promotionsData
      .filter((promotion) => promotion.featuredPromotion)
      .sort((a, b) => a.priority - b.priority)
  }, [])

  const nextPromotion = useMemo(() => {
    const dayMap = { thursdayPromotion: 4, fridayPromotion: 5 }
    const currentDay = new Date().getDay()

    const filtered = promotionsData.filter(
      (p) => p.highlightPromotion && (p.thursdayPromotion || p.fridayPromotion)
    )

    const sorted = filtered
      .map((p) => {
        const day =
          dayMap[p.thursdayPromotion ? "thursdayPromotion" : "fridayPromotion"]
        let diff = day - currentDay
        if (diff <= 0) diff += 7
        return { ...p, diff }
      })
      .sort((a, b) => a.diff - b.diff)

    return promotionsData.find((p) => p.isShowOnFeatured) || sorted[0]
  }, [])

  const modalComponents = {
    "2/30 Lottery Draw": ModulesLotteryDraw,
    "Pera O Bayong": ModulesPeraBayong,
    "JDB Exclusive Promo": ModuleJustDoYourBest,
    "FC Grand Spin-Ale": ModuleFaChaiGrandSpinAle,
    "Flexi-Spin Showdown": ModuleFlexiShowDown,
    "CQ9 Funalo": ModuleCQ9Funalo,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const requireLogin = (callback) => {
    if (isLoggedIn) callback()
    else setLogin(true)
  }

  const hiddenTitlesForPlayNow = [
    "Pera O Bayong",
    "Exclusive Rolling Commission",
    "2/30 Lottery Draw",
    "8's Your Lucky Draw",
    "CQ9 Funalo",
  ]

  const hiddenTitlesForJili = [
    ...hiddenTitlesForPlayNow,
    "Pragmatic Play Daily",
    "Recovery Bonus",
    "Flexi-Spin Showdown",
    "8PM Recovery Hour",
    "CQ9 Funalo",
  ]

  const handlePromoAction = (title) => {
    const actions = {
      "Easter Egg Drop": () => setShowEasterEgg(true),

      "Exclusive Rolling Commission": () =>
        requireLogin(() => setShowRolling(!showRolling)),

      "2/30 Lottery Draw": () => requireLogin(() => setActiveModal(title)),

      "Flexi-Spin Showdown": () => requireLogin(() => setActiveModal(title)),

      "CQ9 Funalo": () => requireLogin(() => setActiveModal(title)),

      "FGH RECOVERY BONUS is back!": () =>
        requireLogin(() => setIsDepositOpen(true)),

      "8PM Recovery Hour": () => requireLogin(() => setIsDepositOpen(true)),

      "Pera O Bayong": () => setActiveModal(title),

      "JDB Exclusive Promo": () => setActiveModal(title),

      "Pragmatic Play Daily": () =>
        (window.location.href = "/slots/?provider=PP"),

      "Pragmatic Play Zombie School": () =>
        (window.location.href = "/slots/?provider=PP"),

      "8's Your Lucky Draw": () => requireLogin(() => setIsShowViewEntry(true)),
    }

    return actions[title]
      ? actions[title]()
      : (window.location.href = "/slots/?provider=JILI")
  }

  return (
    <>
      {login && <LoginToPlay onClose={() => setLogin(false)} />}
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
      {showRolling && (
        <RollingCommission onClose={() => setShowRolling(false)} />
      )}
      {isShowViewEntry && (
        <LuckyDraw8 onClose={() => setIsShowViewEntry(false)} />
      )}

      <div className="featured-promotion-container">
        {/* MAIN BANNER BUTTON */}
        {isFeaturedPromoOpen && nextPromotion && (
          <div className="featured-promotion-btn" onClick={handlePromoPop}>
            <div className="featured-promotion-btn-content">
              <img src={nextPromotion.imgIcon} alt={nextPromotion.title} />
              <div>
                <strong className="featured-promotion-popup-text">
                  {nextPromotion.title}
                </strong>
                <p className="featured-promotion-sub-text">
                  {nextPromotion.subHeading}
                </p>
              </div>
            </div>
            <CountdownTimer {...nextPromotion} />
          </div>
        )}

        {/* POPUP CONTENT */}
        {isFeaturedPromoPop && (
          <div className="featured-promo-pop-container">
            {featuredPromotions.map((promotion) => {
              if (promotion.title === "Pera O Bayong" && !showMysteryFridayBtn)
                return null

              const hidePlayNow = hiddenTitlesForPlayNow.includes(
                promotion.title
              )
              const hideJili = hiddenTitlesForJili.includes(promotion.title)

              return (
                <div key={promotion.id} className="featured-promo-pop-items">
                  <img
                    src={promotion.highlightImgSrc}
                    alt={promotion.title}
                    className="featured-promo-pop-img"
                  />

                  <div className="featured-promo-pop-details">
                    <div>
                      <strong>{promotion.title}</strong>
                      <p>
                        {promotion.userQualification}
                        <span className="promotion-user-rewards">
                          {promotion.userRewards}
                        </span>
                      </p>
                    </div>

                    {/* Play Now (Double Up Eligible) */}
                    {doubleUpTurnover >= 100000
                      ? !hidePlayNow && (
                          <button
                            className="featured-promo-pop-btn"
                            onClick={() => {
                              setIsShowDoubleUp(false)
                              setTimeout(() => setIsShowDoubleUp(true), 0)
                            }}
                          >
                            Play Now
                          </button>
                        )
                      : !hideJili && (
                          <a
                            className="featured-promo-pop-btn"
                            href="/slots/?provider=JILI"
                          >
                            Play Now
                          </a>
                        )}

                    {/* Custom Action Button */}
                    {promotion.title !== "Double Up" &&
                      promotion.title !== "FGH Sign-Up Treat" && (
                        <button
                          className="featured-promo-pop-btn"
                          onClick={() => handlePromoAction(promotion.title)}
                        >
                          {promotion.btnTxt}
                        </button>
                      )}
                  </div>
                </div>
              )
            })}

            <p onClick={handleClosePop} className="featured-promo-close-btn">
              close
            </p>
          </div>
        )}

        {/* DEPOSIT MODAL */}
        {isDepositOpen &&
          createPortal(
            <div className="modal-portal">
              <Deposit
                onClose={() => setIsDepositOpen(false)}
                defaultBonusName="New Member Package Bonus"
              />
            </div>,
            document.body
          )}
      </div>
    </>
  )
}
